module.exports = __webpack_public_path__ + "img/sozialschnellgut_3_b.2e7b33fa.jpg";